<template>
  <header class="marketing-email-header">
    <button class="btn btn-round btn-primary" @click="showCreateTypeModal">
      {{ $t("message.email.message.createEmail") }}
    </button>

    <div class="marketing-email-header-tabs">
      <tab-selector
        v-model="tab"
        :data-tabs="tabs"
        @input="emitTab"
      ></tab-selector>
    </div>

    <app-search-bar
      class="marketing-email-header-search"
      v-model="search"
      @enter="emitMarketingSearch"
    />

    <i
      v-tooltip="$t('message.email.message.validateDomains')"
      class="mdi mdi-settings pointer marketing-email-header-action"
      @click="openDomainValidation"
    ></i>

    <i
      v-if="!isPartnerLoggedAs"
      v-tooltip="$t('message.marketingGenerics.message.creditHistory')"
      class="mdi mdi-file-document-outline pointer marketing-email-header-action"
      @click="openCreditsList"
    ></i>

    <marketing-credits-modal v-model="showCreditsModal" channel-type="EMAIL" />

    <domain-modal :showing.sync="showingDomainValidationModal" />

    <marketing-create-modal-type
      v-model="showingCreateTypeModal"
      email
      @nextStep="goToNextCreationStep"
    />
  </header>
</template>

<script>
import DomainModal from "@components/modules/domain/modal/DomainModal";
import TabSelector from "@components/TabSelector";
import MarketingCreditsModal from "@components/modules/marketing/generic/credits/modal/MarketingCreditsModal";
import MarketingCreateModalType from "@components/modules/marketing/generic/create/modal/type/MarketingCreateModalType";
import EventBus from "@packages/event-bus";
import AppSearchBar from "@components/Search";

export default {
  components: {
    AppSearchBar,
    MarketingCreditsModal,
    MarketingCreateModalType,
    TabSelector,
    DomainModal,
  },

  computed: {
    user() {
      return this.$store.state.users.user;
    },    
    isPartnerLoggedAs() {
      return this.$store.state.users.parceiro;
    },
    tabs() {
      return [
        {
          label: this.$t("message.marketingGenerics.message.singleSend"),
          value: false,
        },

        {
          label: this.$t("message.marketingGenerics.message.automation"),
          value: true,
        },
      ];
    },
  },

  data() {
    return {
      step: 0,
      search: "",
      showCreditsModal: false,
      showingDomainValidationModal: false,
      showingCreateTypeModal: false,
      tab: undefined,
      form: {
        title: undefined,
      },
    };
  },

  methods: {
    emitMarketingSearch() {
      EventBus.$emit("EMAIL_SET_SEARCH", this.search);
    },
    openCreditsList() {
      this.showCreditsModal = true;
    },
    hideCreditsList() {
      this.showCreditsModal = false;
    },
    showCreateTypeModal() {
      this.showingCreateTypeModal = true;
    },
    goToNextCreationStep({ isAutomationFlow, title }) {
      this.$store.commit("EMAIL_CREATE_SET_TITLE", title);
      this.$store.commit("EMAIL_CREATE_SET_AUTOMATION", isAutomationFlow);

      this.$router.push({
        path: "/marketing/email/criar/modelo",
      });
    },
    emitTab(value) {
      EventBus.$emit("EMAIL_SMS_LIST_TAB", value);
    },
    openDomainValidation() {
      this.showingDomainValidationModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-header {
  display: flex;
  align-items: center;

  .marketing-email-header-action {
    font-size: 25px;
    color: #707070;
    margin-right: 10px;
  }

  .marketing-email-header-tabs {
    width: 400px;
    margin: 0 auto;
    font-weight: 600;
  }

  .marketing-email-header-search {
    flex: 0;
    min-width: 200px;
    margin-right: 40px !important;
    padding-top: 0 !important;
  }
}
</style>
